


























import {
  CarpsaleManagementCarpsaleService,
  StoreManagementListItemRequest,
} from "@/common/api";
import QErrors from "@/common/qErrors.vue";
import { debounce } from "lodash";
import { Component, PropSync } from "vue-property-decorator";
import { Vue } from "vue-property-decorator";
import vSelect from "vue-select";

@Component({
  name: "qSelectCarpsale",
  components: { QErrors, vSelect },
})
export default class qSelectCarpsale extends Vue {
  get hasNextPage() {
    return this.paginator.currentPage < this.paginator.lastPages;
  }
  @PropSync("itemId", {
    default: 0,
  })
  public itemIdSync;

  @PropSync("selectedItem", {
    default: () => {
      return {};
    },
  })
  public selectedItemSync;

  public search = "";
  public limit = 30;
  public observer = null;
  public items = [];
  public paginator: any = {
    currentPage: 1,
    lastPages: 1,
    perPage: 30,
    total: 0,
  };
  public filter = {
    sort: "code",
    direction: StoreManagementListItemRequest.direction.ASC,
    perPage: 30,
    page: 1,
    disabledLoadinng: true,
  };
  public item = null;

  public fetchOption = debounce((search) => {
    this.search = search;
    this.filter.page = 1;
    this.paginator.currentPage = 1;
    this.getItems({ ...this.filter, nameOrCode: search });
  }, 500);

  public mounted() {
    this.observer = new IntersectionObserver(this.infiniteScroll as any);
  }

  public async onOpen() {
    this.items = [];
    await this.getItems({ ...this.filter, nameOrCode: this.search });
    if (this.$refs.load) {
      this.observer.observe(this.$refs.load);
    }
  }

  public onClose() {
    this.observer?.disconnect();
    this.filter.page = 1;
  }

  public async infiniteScroll([{ isIntersecting, target }]) {
    if (isIntersecting) {
      const ul = target.offsetParent;
      const scrollTop = target.offsetParent.scrollTop;
      this.paginator.currentPage += 1;
      this.filter.page = this.paginator.currentPage;
      await this.getItems(
        { ...this.filter, nameOrCode: this.search },
        this.items,
      );
      ul.scrollTop = scrollTop;
    }
  }

  public async getItems(query = {}, items = []) {
    const result = await CarpsaleManagementCarpsaleService.adminCarpsale(query);
    this.paginator = result.data.paginator;
    this.items = [...items, ...result.data.items];
  }

  public selecteItem() {
    this.$emit("input", this.selectedItemSync);
  }
}
